export const lightTheme = {
  colors: {
    palette: {
      slate300: '#CBD5E1',
      green500: '#22C55E',
      red500: '#EF4444',
      blue500: '#3B82F6',
      yellow500: '#EAB308',
    },
  },
}; 